import React, { FunctionComponent } from "react";
import { ILoginPageProps, Login } from "./component";

export const LoginContainer: FunctionComponent<ILoginPageProps> = ({
  isMinimalist,
  loginCallback
}) => {
  return <Login isMinimalist={isMinimalist} loginCallback={loginCallback} />;
};
